import styled, { keyframes } from 'styled-components';
import { CalciteCard } from 'components/Calcite';

const fadeInFromBottom = keyframes`
  from {
    opacity: 0;
    margin: 10rem 1rem 0 0;
  }
  to {
    opacity: 1;
    margin: 1rem 1rem 0 0;
  }
`;

export const StyledCalciteCard = styled(CalciteCard)`
  animation: ${fadeInFromBottom} 2000ms forwards cubic-bezier(0.4, 0, 0.2, 1);
`;
